import { useQuery } from "@tanstack/react-query";
import { journalServiceClient } from "@/connect";
import type { GetDecisionsRequest } from "@/types/proto/api/v1/memo_service_pb";

export const decisionKeys = {
  all: ["decisions"] as const,
  list: (filters: Partial<GetDecisionsRequest>) => [...decisionKeys.all, "list", filters] as const,
};

/**
 * React Query hook for fetching decisions
 *
 * @param request - Partial GetDecisionsRequest with filters (ticker, contractUid, decision, actionType, from_ts, to_ts, page_size, page_token)
 * @returns Query result with decisions data
 */
export function useDecisions(request: Partial<GetDecisionsRequest> = {}) {
  return useQuery({
    queryKey: decisionKeys.list(request),
    queryFn: async () => {
      const response = await journalServiceClient.getDecisions(request as GetDecisionsRequest);
      return response;
    },
    staleTime: 1000 * 60 * 2, // 2 minutes
    gcTime: 1000 * 60 * 5,
  });
}
